import React, { Component } from 'react'
import Navbar from './NavbarScanner';
// import Sidebar from './SidebarScanner';
import Sidebar from "./Sidebar"
import QrReader from 'react-web-qr-reader';
import ScannerPopup from './ScannerPopup';

export class ScannerByCamera extends Component {
    constructor(props) {
        super(props)
        this.state = {
            result: null,
            showModalPopup: false,
            facingModes: "environment",
        }

        this.handleScan = this.handleScan.bind(this);
        this.isShowPopup = this.isShowPopup.bind(this);
        this.cameraMode = this.cameraMode.bind(this)
    }

    isShowPopup = (status) => {
        this.setState({ showModalPopup: status });
    }

    isClosePopup = () => {
        this.setState({ showModalPopup: false, result: null });
    }

    handleScan(data) {
        try {
            if (data && data.data) {
                const parsedData = JSON.parse(data.data);
                this.setState({
                    result: parsedData
                });
                this.isShowPopup(true);
            }
        } catch (e) {
            alert("Scanned QR is Invalid");
        }
    }

    handleEror(err) {
        console.log(err)
    }

    cameraMode(data) {
        this.setState({
            facingModes: data
        })
    }

    render() {
        const previewStyle = {
            height: 300,
            width: 300,
            display: 'flex',
            justifyContent: "center"
        }

        const camStyle = {
            display: 'flex',
            justifyContent: "center",
        }

        return (
            <>
                <Sidebar />
                <div className='main'>
                    <div className='topbar'>
                        <Navbar />
                    </div>

                    <div className="container">
                        <div className='row'>
                            <div className='col-12'>
                                <h2 className="text-center"><u><strong>QR CODE SCANNER</strong></u></h2>
                            </div>
                        </div>

                        <div className='row'>
                            <div style={camStyle}>
                                <QrReader
                                    delay={1000}
                                    style={previewStyle}
                                    onError={this.handleEror}
                                    onScan={this.handleScan}
                                    facingMode={this.state.facingModes}
                                />
                            </div>
                            <div className='row'>
                                <div className="btn-group btn-group-toggle mt-2 mb-5" data-toggle="buttons">
                                    <label className="btn" id="frontCamera" style={{ color: "#000", border: "1px solid #ccc" }} onClick={() => this.cameraMode("user")}>
                                        <input type="radio" name="options" value="1" /> Front Camera
                                    </label>
                                    <label className="btn" id="backCamera" style={{ color: "#000", border: "1px solid #ccc" }} onClick={() => this.cameraMode("environment")}>
                                        <input type="radio" name="options" value="2" /> Back Camera
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {this.state.showModalPopup && this.state.result ? (
                    <ScannerPopup
                        showModalPopup={this.state.showModalPopup}
                        result={this.state.result}
                        onPopupCloseMain={this.isClosePopup}
                    />
                ) : ""}
            </>
        )
    }
}

export default ScannerByCamera;

